import axios from 'axios'
import store from '@/store/store'
import config from '@/config/default'

export default () => {
  return axios.create({
    baseURL: config.axiosBaseUrl(),
    headers: {
      Authorization: `Bearer ${store.state.token}`
    },
    withCredentials: true
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js